export default __webpack_public_path__ + "static/media/invoiceChange.8843c86c.png";